const GEO_CACHE_KEY = 'i18n_geo_lng';
const GEO_TIMEOUT_MS = 3000;

const COUNTRY_TO_LANGUAGE: Record<string, string> = {
  // German
  DE: 'de',
  AT: 'de',
  CH: 'de',
  LI: 'de',

  // French
  FR: 'fr',
  BE: 'fr',
  LU: 'fr',
  MC: 'fr',

  // Italian
  IT: 'it',
  SM: 'it',
  VA: 'it',

  // Spanish
  ES: 'es',
  MX: 'es',
  AR: 'es',
  CO: 'es',
  CL: 'es',
  PE: 'es',
  VE: 'es',
  EC: 'es',
  GT: 'es',
  CU: 'es',
  BO: 'es',
  DO: 'es',
  HN: 'es',
  PY: 'es',
  SV: 'es',
  NI: 'es',
  CR: 'es',
  PA: 'es',
  UY: 'es',
  PR: 'es',

  // English
  US: 'en',
  GB: 'en',
  AU: 'en',
  NZ: 'en',
  CA: 'en',
  IE: 'en',
};

export async function fetchAndCacheGeoLanguage(): Promise<string | null> {
  if (typeof window === 'undefined') return null;

  if (localStorage.getItem(GEO_CACHE_KEY)) {
    return localStorage.getItem(GEO_CACHE_KEY);
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), GEO_TIMEOUT_MS);

    const response = await fetch('https://ipapi.co/json/', {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);

    const data = await response.json();
    const language = COUNTRY_TO_LANGUAGE[data.country_code] ?? null;

    if (language) {
      localStorage.setItem(GEO_CACHE_KEY, language);
    }

    return language;
  } catch {
    return null;
  }
}

export const geoDetector = {
  name: 'geo',
  lookup(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    return localStorage.getItem(GEO_CACHE_KEY) || undefined;
  },
};
